<div class="d-flex gap-1 flex-wrap">
    @for (option of options; track option) {
        <lib-icon-button 
            [qaTag]="option.qaTag"
            [icon]="option.icon"
            [size]="option.size"
            [kind]="option.kind"
            [active]="selected == option.value"
            (clicked)="SelectionChange(option.value)">
        </lib-icon-button>
    }
</div>
